import Service from '../../Services/Service';

const VenueHireAPI = {
    getVenueHire(lang,branch_id){
        return Service.get(`/service/branch/venue_hire/${branch_id}?lang=${lang}`);
    },
    getVenueHireType(){
        return Service.get(`/service/get_venue_hire_type`);
    }
}
export default VenueHireAPI
